import { httpDelete, httpGet, httpPost, httpPut } from "../../Http/HttpClient";
import { authService } from "../../index";
import {
  CreateClientAction,
  CreateClientPerformanceGroupAction,
  createClientPerformanceGroupSuccess,
  createClientSuccess,
  CreateUserAction,
  createUserSuccess,
  CREATE_CLIENT,
  CREATE_CLIENT_PERFORMANCE_GROUP,
  CREATE_NIADA_USER,
  CREATE_USER,
  DeleteClientPerformanceGroupAction,
  deleteClientPerformanceGroupSuccess,
  DELETE_CLIENT_PERFORMANCE_GROUP,
  GetClientPerformanceGroupsAction,
  getClientPerformanceGroupsSuccess,
  GET_CLIENT_PERFORMANCE_GROUPS,
  LoadClientsAction,
  loadClientsSuccess,
  LoadPerformanceGroupsAction,
  loadPerformanceGroupsSuccess,
  LoadUsersAction,
  LoadUsersForClientAction,
  loadUsersForClientSuccess,
  loadUsersSuccess,
  LOAD_CLIENTS,
  LOAD_PERFORMANCE_GROUPS,
  LOAD_USERS,
  LOAD_USERS_FOR_CLIENT,
  RemoveDpgUserAction,
  removeDpgUserSuccess,
  RemoveUserAction,
  removeUserSuccess,
  REMOVE_NIADA_USER,
  REMOVE_USER,
  ResendUserInviteAction,
  resendUserInviteSuccess,
  RESEND_USER_INVITE,
  UpdateClientAction,
  UpdateClientPerformanceGroupAction,
  updateClientPerformanceGroupSuccess,
  updateClientSuccess,
  UpdateUserAction,
  updateUserSuccess,
  UPDATE_CLIENT,
  UPDATE_CLIENT_PERFORMANCE_GROUP,
  UPDATE_USER,
  LoadModeratorsAction,
  loadModeratorsSuccess,
  LOAD_MODERATORS
} from "./actions";
import { put, takeLatest, all, call } from 'redux-saga/effects';
import { Client, LookupItem } from "@amsanalytics/react-shared-library";
import { displayError } from "../../Helpers/Utilities";
import { NiadaUser, User } from "../../Models/User";
import { ClientPerformanceGroup } from "../../Models/ClientPerformanceGroup";

function* loadClientsSaga(action: LoadClientsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpGet,
      `${authService.appSettings.GetWebApiBaseUri()}/client`,
      token
    );
    const clients: Client[] = yield call([response, response.json]);
    yield put(loadClientsSuccess(clients));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchLoadClients() {
  yield takeLatest(LOAD_CLIENTS, loadClientsSaga);
}

function* createClientSaga(action: CreateClientAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpPost,
      `${authService.appSettings.GetWebApiBaseUri()}/client/create`,
      { client: action.payload.client },
      token
    );
    yield put(createClientSuccess(action.payload.client));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchCreateClient() {
  yield takeLatest(CREATE_CLIENT, createClientSaga);
}

function* updateClientSaga(action: UpdateClientAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpPut,
      `${authService.appSettings.GetWebApiBaseUri()}/client/update`,
      { client: action.payload.client },
      token
    );
    yield put(updateClientSuccess(action.payload.client));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchUpdateClient() {
  yield takeLatest(UPDATE_CLIENT, updateClientSaga);
}

function* loadUsersSaga(action: LoadUsersAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpGet,
      `${authService.appSettings.GetWebApiBaseUri()}/user`,
      token
    );
    const users: User[] = yield call([response, response.json]);
    yield put(loadUsersSuccess(users));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchLoadUsers() {
  yield takeLatest(LOAD_USERS, loadUsersSaga);
}

function* loadModeratorsSaga(action: LoadModeratorsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpGet,
      `${authService.appSettings.GetWebApiBaseUri()}/clientgroup/moderators`,
      token
    );
    const users: NiadaUser[] = yield call([response, response.json]);
    yield put(loadModeratorsSuccess(users));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchLoadModerators() {
  yield takeLatest(LOAD_MODERATORS, loadModeratorsSaga);
}

function* loadUsersForClientSaga(action: LoadUsersForClientAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpGet,
      `${authService.appSettings.GetWebApiBaseUri()}/user/${action.payload.clientId}`,
      token
    );
    const users: User[] = yield call([response, response.json]);
    yield put(loadUsersForClientSuccess(users));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchLoadUsersForClient() {
  yield takeLatest(LOAD_USERS_FOR_CLIENT, loadUsersForClientSaga);
}

function* createUserSaga(action: CreateUserAction) {
  try {
    const token: string = yield authService.getToken();
    const response: Response | undefined = yield call(httpPost,
      `${authService.appSettings.GetWebApiBaseUri()}/user`,
      action.payload.user,
      token
    );
    if (response && response.ok) {
      const usr: User = yield call([response, response.json]);
      yield put(createUserSuccess(usr));
    } else {
      yield (put(displayError("Could not create this user. A user with this AD User Id may already exist.")));
    }
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchCreateUser() {
  yield takeLatest(CREATE_USER, createUserSaga);
}

function* updateUserSaga(action: UpdateUserAction) {
  try {
    const token: string = yield authService.getToken();
    const response: Response | undefined = yield call(httpPut,
      `${authService.appSettings.GetWebApiBaseUri()}/user`,
      action.payload.user,
      token
    );
    if (response && response.ok) {
      const usr: User = yield call([response, response.json]);
      yield put(updateUserSuccess(usr));
    } else {
      yield (put(displayError(response?.statusText || "Could not update this user.")));
    }

  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchUpdateUser() {
  yield takeLatest(UPDATE_USER, updateUserSaga);
}

function* removeUserSaga(action: RemoveUserAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpDelete,
      `${authService.appSettings.GetWebApiBaseUri()}/user/${action.payload.adUserId}`,
      token
    );
    yield put(removeUserSuccess(action.payload.adUserId));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchRemoveUser() {
  yield takeLatest(REMOVE_USER, removeUserSaga);
}

function* resendUserInviteSaga(action: ResendUserInviteAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpGet,
      `${authService.appSettings.GetWebApiBaseUri()}/user/resendinvite/${action.payload.adUserId}`,
      token
    );
    yield put(resendUserInviteSuccess(action.payload.adUserId));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchResendUserInvite() {
  yield takeLatest(RESEND_USER_INVITE, resendUserInviteSaga);
}


function* removeDpgUserSaga(action: RemoveDpgUserAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpDelete,
      `${authService.appSettings.GetWebApiBaseUri()}/user/dpg/${action.payload.adUserId}`,
      token
    );
    yield put(removeDpgUserSuccess(action.payload.adUserId));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchRemoveDpgUser() {
  yield takeLatest(REMOVE_NIADA_USER, removeDpgUserSaga);
}

export function* loadPerformanceGroupsSaga(action: LoadPerformanceGroupsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpGet, `${authService.appSettings.GetWebApiBaseUri()}/performanceGroup/all`, token);
    const performanceGroups: LookupItem[] = yield call([response, response.json]);
    yield put(loadPerformanceGroupsSuccess(performanceGroups));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchLoadPerformanceGroups() {
  yield takeLatest(LOAD_PERFORMANCE_GROUPS, loadPerformanceGroupsSaga);
}

export function* getClientPerformanceGroupsSaga(action: GetClientPerformanceGroupsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpGet, `${authService.appSettings.GetWebApiBaseUri()}/client/performanceGroups/${action.payload.clientId}`, token);
    const performanceGroups: ClientPerformanceGroup[] = yield call([response, response.json]);
    yield put(getClientPerformanceGroupsSuccess(performanceGroups));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchGetClientPerformanceGroups() {
  yield takeLatest(GET_CLIENT_PERFORMANCE_GROUPS, getClientPerformanceGroupsSaga);
}

export function* createClientPerformanceGroupSaga(action: CreateClientPerformanceGroupAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpPost, `${authService.appSettings.GetWebApiBaseUri()}/client/clientPerformanceGroup`, action.payload.clientPerformanceGroup, token);
    const performanceGroup: ClientPerformanceGroup = yield call([response, response.json]);
    yield put(createClientPerformanceGroupSuccess(performanceGroup));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchCreateClientPerformanceGroup() {
  yield takeLatest(CREATE_CLIENT_PERFORMANCE_GROUP, createClientPerformanceGroupSaga);
}

export function* updateClientPerformanceGroupSaga(action: UpdateClientPerformanceGroupAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpPut, `${authService.appSettings.GetWebApiBaseUri()}/client/clientPerformanceGroup`, action.payload.clientPerformanceGroup, token);
    const performanceGroup: ClientPerformanceGroup = yield call([response, response.json]);
    yield put(updateClientPerformanceGroupSuccess(performanceGroup));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchUpdateClientPerformanceGroup() {
  yield takeLatest(UPDATE_CLIENT_PERFORMANCE_GROUP, updateClientPerformanceGroupSaga);
}

export function* deleteClientPerformanceGroupSaga(action: DeleteClientPerformanceGroupAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any } = yield call(httpDelete, `${authService.appSettings.GetWebApiBaseUri()}/client/clientPerformanceGroup/${action.payload.clientPerformanceGroupId}`, token);
    yield put(deleteClientPerformanceGroupSuccess(action.payload.clientPerformanceGroupId));
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchDeleteClientPerformanceGroup() {
  yield takeLatest(DELETE_CLIENT_PERFORMANCE_GROUP, deleteClientPerformanceGroupSaga);
}

export default function* adminSagas() {
  yield all([
    watchLoadClients(),
    watchCreateClient(),
    watchUpdateClient(),
    watchLoadUsers(),
    watchLoadUsersForClient(),
    watchCreateUser(),
    watchUpdateUser(),
    watchRemoveUser(),
    watchResendUserInvite(),
    watchRemoveDpgUser(),
    watchLoadPerformanceGroups(),
    watchGetClientPerformanceGroups(),
    watchCreateClientPerformanceGroup(),
    watchUpdateClientPerformanceGroup(),
    watchDeleteClientPerformanceGroup(),
    watchLoadModerators()
  ])
}